import React, { FunctionComponent } from 'react';
import { Card } from 'rs-emd-ui-atoms';
import { RecentlyViewedProduct } from '../../../../../../generated/graphql';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { ProductListingProduct } from '../../../../models/my-account/product-listing/product-listing-item/product-listing-item-component.model';
import ProductListing from '../../../user/my-account/product-listing/product-listing-component';
import { ProductListingItem } from '../../../user/my-account/product-listing/product-listing-item/product-listing-item-component';
import sharedStyles from '../recently-viewed-shared.module.scss';

type RecentlyViewedProductsProps = {
  labels?: ILabel[];
  data?: RecentlyViewedProduct[] | null;
  onClickItemCallback?: (product: ProductListingProduct) => void;
};

export const RecentlyViewedProducts: FunctionComponent<RecentlyViewedProductsProps> = (props: RecentlyViewedProductsProps) => {
  return (
    <Card className={`${sharedStyles['overview-card']} ${sharedStyles['list-container']}`} padding={false}>
      <ProductListing
        title={getLabel(props.labels, 'recently_viewed_products')}
        tabletWidth='29.2rem'
        elt={ProductListingItem}
        labels={props.labels}
        items={
          props.data?.slice(0, 4).map(
            (product) =>
              ({
                ...product,
                price: product.price.priceAfter,
              } as ProductListingProduct)
          ) ?? undefined
        }
        {...props}
      />
    </Card>
  );
};
